import FJConfig from '../config/FJConfig';

import FJNetworkManager from '../core/FJNetworkManager';
import FJUtil from './FJUtil';
import FJMessageStore from '../store/FJMessageStore';
import FJLocalStore from '../store/FJLocalStore';
import FJVideoUtil from './FJVideoUtil';
import { getLtsUploadSource } from './FJLongToShortEa';

const FJRequirementsUtil = {
    isLocalhost: function () {
        return Boolean(
            window.location.hostname === 'localhost' ||
            // [::1] is the IPv6 localhost address.
            window.location.hostname === '[::1]' ||
            // 127.0.0.1/8 is considered localhost for IPv4.
            window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/) ||
            window.location.hostname.match(/^192.168(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){2}$/),
        );
    },
    getUserId() {
        let uid;
        if (window?.fjuser?.info?.id) {
            uid = window.fjuser.info.id;
        } else {
            uid = '';
        }
        return uid;
    },
    getCurrentSpaceId: function () {
        return window.fjuser.info.current_space_id;
    },
    getCurrentSpaceType: function () {
        return window.fjuser?.info?.space_type || 'personal';
    },
    anonymousSignUp: function () {
        return new Promise((resolve, reject) => {
            try {
                FJRequirementsUtil.eaLog('long_to_shorts_login_window_page_view', { source: getLtsUploadSource() });
                window.PanelFunc.showSignUpPane();
                window.loginToCreateProjectCallback = () => {
                    resolve();
                };
            } catch (e) {
                reject(e);
            }
        });
    },
    getLanguage: function (tag, callback) {
        fetch(FJConfig.LANGUAGE_PATH + tag + '.json?v=' + FJConfig.version)
            .then(res => res.json())
            .then(json => {
                callback(json);
            })
            .catch(err => {
                console.log(err);
            });
    },
    /**
     * @desc 添加统计
     * @param {string} eventType - 类型
     * @param {{}} eventData - 数据
     */
    eaLog(eventType, eventData = {}) {
        const data = {
            ...eventData,
            'app mode': 'ai long to short',
            'app version': FJConfig.VERSION,
        };

        if (window.ealog && window.ealog.addEvent) {
            window.ealog.addEvent(eventType, data);
        } else {
            console.log(eventType, data);
        }
    },
    /**
     * @desc 获取积分
     * @param {*} appType （不传就从FJConfig.appType获取）
     */
    getCredits: function () {
        const isFreePayment = this.isFreePayment();
        FJRequirementsUtil.eaLog('long_to_shorts_credit_window_page_view', { isFreePayment });
        const entry = 'long to short';
        if (window.openSubscription) {
            if (isFreePayment) {
                window.openSubscription({
                    entry: entry,
                    panelName: 'Subscription',
                    method: 'popup',
                    showCreditRuleTable: false,
                    showQuestionnaire: false,
                    useNewSubscribeModal: true,
                    newSubscribeModalOptions: {
                        personal: {
                            title: FJLocalStore._('upgrade-now-long-video-to-viral-shorts-in-one-click'),
                        },
                        team: {
                            title: FJLocalStore._('upgrade-now-long-video-to-viral-shorts-in-one-click'),
                        },
                    },
                });
            } else {
                window.openSubscription({
                    entry: entry,
                    panelName: 'Credits',
                    showCreditRuleTable: false,
                    showQuestionnaire: false,
                    useNewCreditModal: true,
                    useNewCreditModalABtest: isFreePayment,
                });
            }
        }
    },
    isLogin: function () {
        return FJRequirementsUtil.isLocalhost() || (window.uid && window.uid !== -1);
    },
    login: function (loginCallback) {
        this.anonymousSignUp()
            .then(() => {
                if (loginCallback) {
                    loginCallback();
                } else {
                    this.updateAllCreditInfo();
                }
            })
            .catch(e => console.log(e));
    },
    checkIsLogin: async function (loginCallback, errorCallback) {
        const __login = () => {
            this.anonymousSignUp()
                .then(() => {
                    if (loginCallback) {
                        loginCallback();
                    } else {
                        this.updateAllCreditInfo();
                    }
                })
                .catch(e => console.log(e));
        };
        try {
            if (FJUtil.isLocalhost()) {
                return true;
            }
            if (!this.isLogin()) {
                __login();
                return false;
            } else {
                const isLogin = await FJNetworkManager.checkIsLogin();
                if (!isLogin) {
                    __login();
                    return false;
                }
            }
            return true;
        } catch (error) {
            if (errorCallback) {
                errorCallback();
            } else {
                FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
            }
            return false;
        }
    },

    getPaymentLevel: function () {
        return window?.fj?.currentPlan?.package;
    },
    isTeamSpace: function () {
        return this.getCurrentSpaceType() === 'team';
    },
    getTeamPayment: function () {
        const spaceItems = window?.fjuser?.info?.space_items;
        const tid = this.getCurrentSpaceId();
        if (spaceItems && spaceItems.length > 0) {
            const spaceItem = spaceItems.find(item => item.id === tid);
            if (spaceItem) {
                return spaceItem.policy;
            }
        }
        return window.fjuser?.info?.current_policy;
    },
    // 是否是免费用户
    isFreePayment: function () {
        if (FJUtil.isLocalhost()) {
            return true;
        }
        if (this.isTeamSpace()) {
            return this.getTeamPayment() === 'free';
        }
        return this.getPaymentLevel() === 'free';
    },
    /**
     * @desc: 更新所有位置用户积分界面
     * @param {boolean} updateFreeLimit - 是否更新免费额度(使用了免费次数需要更新)
     */
    updateAllCreditInfo: function (updateFreeLimit) {
        if (window.fj && window.fj.event && window.fj.event.dispatch) {
            window.fj.event.dispatch('UPDATE_USER_CREDITS', updateFreeLimit);
        }
    },
};
export default FJRequirementsUtil;
